// extracted by mini-css-extract-plugin
export default {"service":"Farmers_service__6Attb","imagenes":"Farmers_imagenes__fWc4X","big":"Farmers_big__6LUNK","littles":"Farmers_littles__e65qX","containt":"Farmers_containt__MsrWT"};